// extracted by mini-css-extract-plugin
export var copyIcon = "_r6-2";
export var discountCard = "_r6-0";
export var discountCode = "_r6-3";
export var discountContent = "_r6-1";
export var loadingCard = "_r6-4";